<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="40%"
    top="15vh"
    append-to-body
    class="success-modal"
  >
    <el-row slot="title">
      <h2>ЗАДАНИЕ СОЗДАНО УСПЕШНО</h2>
    </el-row>
    <el-row class="text"> Перейти к добавлению контактов? </el-row>
    <el-row type="flex" justify="space-between" class="btn-block">
      <el-button type="info" plain @click="$emit('finish')">
        Закончить
      </el-button>
      <el-button type="primary" @click="$emit('next')"> Да </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  name: 'SuccessModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass">
.success-modal
  h2
    margin: 30px
    font-weight: bold
    font-size: 16px
    line-height: 17px
  .el-dialog__body
    font-size: 16px
    color: #000
    padding: 0 50px 50px
    .text
      margin: 30px 0 100px
    .btn-block
      .el-button
        font-size: 16px
        font-family: Rubik, sans-serif
        font-weight: normal
      button
        width: 200px
        height: 60px
</style>
